export default __webpack_public_path__ + "static/media/board_ko.a19cf44a.png";